import { render, staticRenderFns } from "./GirlIllustration.vue?vue&type=template&id=86bdccee&scoped=true&"
import script from "./GirlIllustration.vue?vue&type=script&lang=js&"
export * from "./GirlIllustration.vue?vue&type=script&lang=js&"
import style0 from "./GirlIllustration.vue?vue&type=style&index=0&id=86bdccee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bdccee",
  null
  
)

export default component.exports